import AdminTable from 'layouts/AdminTable';
import Tooltip from '@material-ui/core/Tooltip';
import { Info } from '@material-ui/icons';
import FormLabel from '@material-ui/core/FormLabel';
import LogView from 'components/History/LogView';
import GridItem from 'components/Grid/GridItem';
import SelectInput from 'components/FormSelect/SelectInput';
import GridContainer from 'components/Grid/GridContainer';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import FormImageUpload from 'components/FormImageUpload/FormImageUpload';
import makeStyles from '@material-ui/styles/makeStyles';
import FormTextInputTranslatable from 'components/FormTextInput/FormTextInputTranslatable';
import InfoIconTooltip from 'components/InfoIconTooltip/InfoIconTooltip';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import RegularCheckbox from 'components/Checkbox/RegularCheckbox';
import FormControlStickyButton from 'components/FormControlStickyButton/FormControlStickyButton';

const useStyles = makeStyles(() => ({
  labelHorizontal: extendedFormsStyle.labelHorizontal,
  label: extendedFormsStyle.label,
  uploaderImageWrapper: { marginLeft: '-30px', marginTop: '16px' },
  adminTableTitleParent: { display: 'flex', alignItems: 'center' },
  tooltipIcon: {
    color: 'RGB(130,130,130)',
  },
  displayFlex: {
    display: 'flex',
  },
  tooltip: { marginLeft: '10px' },
  gridItem: { marginLeft: '-15px' },
  marginTop: { marginTop: '20px' },
  spanTooltip: { fontSize: '14px', lineHeight: '22px' },
}));

const FormFiltersView = ({ props }) => {
  const {
    t,
    packages,

    state,
    isLoading,
    isEdit,
    filterLineDietsId,
    handleInputChange,
    handleSelect,
    getImage,
    removeImage,
    handleToggle,
    handleSubmit,
  } = props;
  const classes = useStyles();

  return (
    <>
      {isLoading && (
        <AdminTable
          title={
            <span className={classes.adminTableTitleParent}>
              {isEdit ? t('form.editLine') : t('form.addNewLine.title')}

              <InfoIconTooltip title={t('list.dietsLineFilters.tooltip')} />
            </span>
          }
        >
          <FormTextInputTranslatable
            label={`${t('form.field.lineName')}*`}
            name="name"
            value={state.name}
            handleChange={handleInputChange}
            inputSize={6}
          />
          <FormTextInput
            label={`${t('form.field.order')}*`}
            classes={classes}
            name="position"
            value={state.position}
            type="number"
            handleChange={handleInputChange}
            inputSize={6}
          />
          <FormTextInputTranslatable
            label={t('form.field.description')}
            name="description"
            value={state.description}
            handleChange={handleInputChange}
            inputSize={6}
            multiline={true}
            maxLength={2000}
            isRequired={false}
          />
          <GridContainer>
            <GridItem xs={12} sm={2}>
              <FormLabel className={classes.labelHorizontal}>
                {t('form.field.active2.label')}
                <InfoIconTooltip
                  title={
                    <div>
                      <span className={classes.spanTooltip}>
                        {t('form.activeInfo.filterLineDiets.title')}
                      </span>
                      <span className={classes.spanTooltip}>
                        <ul
                          dangerouslySetInnerHTML={{
                            __html: t(
                              'form.activeInfo.filterLineDiets.description'
                            ),
                          }}
                        />
                      </span>
                    </div>
                  }
                />
              </FormLabel>
              <RegularCheckbox
                name="active"
                checked={state.active}
                onClick={handleToggle}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={6}>
              <SelectInput
                name="packages"
                multiple={true}
                classes={classes}
                label={
                  <div className={classes.displayFlex}>
                    <span>{t('form.field.dietsPackageInLine')} *</span>
                    <div className={classes.tooltip}>
                      <Tooltip
                        title={
                          <div>
                            <span className={classes.spanTooltip}>
                              {t('form.filterPackageDiets.description')}
                            </span>
                          </div>
                        }
                        placement="right"
                      >
                        <Info fontSize="small" />
                      </Tooltip>
                    </div>
                  </div>
                }
                mapBy="name"
                trackBy="@id"
                value={state.packages}
                options={packages.map(pack =>
                  pack.active
                    ? pack
                    : {
                        ...pack,
                        name: `${pack.name} (${t('form.inactive')})`,
                      }
                )}
                handleChange={handleSelect}
              />
            </GridItem>
          </GridContainer>
          <GridContainer className={classes.marginTop}>
            <GridItem>
              <FormLabel className={classes.labelHorizontal}>
                {t('form.field.linePhoto')}
              </FormLabel>
              <div className={classes.uploaderImageWrapper}>
                <FormImageUpload
                  stateName="image"
                  getImage={getImage}
                  removeImage={removeImage}
                  previewUrl={state.imageUrl}
                />
              </div>
            </GridItem>
            <GridItem>
              <FormLabel className={classes.labelHorizontal}>
                {t('form.field.lineIcon')}
              </FormLabel>
              <div className={classes.uploaderImageWrapper}>
                <FormImageUpload
                  buttonText={t('form.field.selectIcon')}
                  isIcon={true}
                  stateName="mainImage"
                  getImage={getImage}
                  removeImage={removeImage}
                  previewUrl={state.mainImageUrl}
                />
              </div>
            </GridItem>
          </GridContainer>
        </AdminTable>
      )}

      {isEdit ? (
        <LogView
          classes={classes}
          discardText={t('form.cancel')}
          submitText={t('form.save')}
          cancelPath="/admin/filter-line-diets"
          handleSubmit={handleSubmit}
          iri={`/package-line-filters/${filterLineDietsId}`}
          customOffsetSmall="10px"
          customOffsetLarge="10px"
          isFixedToBottom={true}
        />
      ) : (
        <FormControlStickyButton
          submitText={t('form.save')}
          discardText={t('form.cancel')}
          classes={classes}
          cancelPath="/admin/filter-line-diets"
          handleSubmit={handleSubmit}
          customOffsetSmall="10px"
          customOffsetLarge="10px"
          isFixedToBottom={true}
        />
      )}
    </>
  );
};

export default FormFiltersView;
